<template>
  <div
    class="formBox d--mvb-3 add-button"
    @click="$emit('handleClick', formName, addFormId)"
    type="button"
    @keydown.enter="$emit('handleClick', formName, addFormId)"
  >
    <div class="form-group d--input-repeater d--pvt-3 align-items-center">
      <div
        class="d--btn-repeater d--text-orange-600 d--btn-repeater-add d--btn-repeater-active"
      >
        <i class="mdi mdi-plus mdi-24px"></i>
      </div>
    </div>
    <a
      class="btn d--text-orange-600 col-xl-10 col-lg-10 col-md-10 col-sm-10 col-10 text-left"
      id="linkText"
      rel="noreferrer noopener nofollow"
      target="_blank"
      >{{ linkText }}</a
    >
  </div>
</template>

<script setup>
const props = defineProps({
  linkText: String,
  formName: String,
  addFormId: Number,
});
</script>

<style scoped>
.add-button {
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px dashed #dde1e6;
  border-radius: 5px;
  padding: 10px;
  box-sizing: border-box;
  width: 100%;
  margin: 0 px 20px 0px 20px;
  text-align: center;
  flex-wrap: wrap;
}

#linkText:hover {
  color: #f29800;
}

/* repeater classes need to be added to css files instead of styling manually */
.d--input-repeater {
  height: 38px;
}

.d--input-repeater .d--btn-repeater {
  border-radius: 50px;
  width: 38px;
  height: 38px;
  padding-top: 7px;
  text-align: center;
  color: #fff;
  display: block;
  transition: 0.5s;
  float: left;
}

.d--input-repeater .d--btn-repeater i {
  width: 24px;
  height: 24px;
  line-height: 1;
}

.d--input-repeater .d--btn-repeater-active {
  background-color: #f29800;
  cursor: pointer;
}

.d--input-repeater .d--btn-repeater-active:hover {
  background-color: #db7900;
}

.d--input-repeater .d--btn-repeater-inactive {
  background-color: #dde1e6;
  cursor: default;
}
</style>
